import type { AppContext__CurrentUser } from './queries.generated';

export const resolveTargetNetwork = (user: AppContext__CurrentUser) => {
  const defaultNetwork = user.defaultNetworkId
    ? user.networks.find((x) => x.id === user.defaultNetworkId)
    : undefined;
  return defaultNetwork ?? user.networks.at(0);
};
